module.exports = __webpack_public_path__ + "static/img/icon_service.390c237e.svg";